import { useDeleteCampaignCapabilityOverrideMutation } from "modules/capabilities/hooks/useDeleteCampaignCapabilityOverrideMutation"
import { useUpsertCampaignCapabilityOverrideMutation } from "modules/capabilities/hooks/useUpsertCampaignCapabilityOverrideMutation"
import { useTranslation } from "react-i18next"
import { CapabilitiesResponseDataSchema } from "schema"
import { toast } from "sonner"
import z from "zod"

type Props = {
  capability: z.infer<typeof CapabilitiesResponseDataSchema>[number]
  campaignId: string
  onClose: () => void
}

export function useCapabilityOverride({ capability, campaignId, onClose }: Props) {
  const { t } = useTranslation()
  const { mutateAsync: upsert, isPending: isUpsertPending } =
    useUpsertCampaignCapabilityOverrideMutation()
  const { mutateAsync: deleteOverride, isPending: isDeletePending } =
    useDeleteCampaignCapabilityOverrideMutation()

  const hasOverride = capability.campaignConfigOverride !== null
  const isPending = isUpsertPending || isDeletePending

  const handleSave = async (configOverride: Record<string, unknown>) => {
    await upsert({ capabilityId: capability.id, campaignId, configOverride })
    toast.success(t("campaigns.capabilities.override.success"))
    onClose()
  }

  const handleDelete = async () => {
    await deleteOverride({ capabilityId: capability.id, campaignId })
    toast.success(t("campaigns.capabilities.override.deleteSuccess"))
    onClose()
  }

  return { hasOverride, isPending, handleSave, handleDelete }
}
